import React from 'react';
import styles from './index.module.scss';

const Button = ({
  onClick,
  disabled,
  text,
  height,
  fontSize = '16px',
  backgroundColor,
  backgroundImage,
  shadowColor,
  borderRadius = '12px',
  showButton = true,
  className = '',
  color = 'white',
  letterSpacing = '0',
  borderWidth = '0',
  borderColor = 'transparent',
  loading = false,
  loaderImg,
  type = 'button',
}) => {
  return (
    <button
      onClick={onClick}
      className={`${styles.button} ${showButton ? styles.visible : styles.hidden} ${className}`}
      style={{
        height: `${height}px`,
        background: shadowColor,
        borderRadius,
        border: `${borderWidth}px solid ${borderColor}`,
      }}
      disabled={disabled}
      type={type}
    >
      <div
        className={styles.buttonText}
        style={{
          height: `${height}px`,
          borderRadius,
          backgroundColor,
          backgroundImage,
          color,
          letterSpacing,
          fontSize,
          border: `${borderWidth}px solid ${borderColor}`,
          width: `calc(100% + ${borderWidth * 2}px)`,
          left: `-${borderWidth}px`,
          top: `-${6 + borderWidth * 2}px`,
        }}
      >
        {loading ? (
          loaderImg ? (
            <img src={loaderImg} alt="Loading..." />
          ) : (
            'Loading...'
          )
        ) : (
          text
        )}
      </div>
    </button>
  );
};

export default Button;
